if (!customElements.get('c-icons-with-text-slider')) {
  class CIconsWithTextSlider extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('.c-icons-with-text-slider__track');
      this.slides = this.querySelectorAll('.c-icons-with-text-slide');
      this.currentIndex = 0;
      this.isPaused = false;
      this.delay = parseInt(this.dataset.slideDelay || '4000', 10);
      this.timeout = null;
      this.mql = window.matchMedia('(max-width: 9999px)');
      this.handleMqChange = this.handleMqChange.bind(this);
    }

    connectedCallback() {
      if (!this.track || this.slides.length <= 1) return;

      this.addEventListener('mouseenter', () => {
        this.isPaused = true;
      });

      this.addEventListener('mouseleave', () => {
        this.isPaused = false;
      });

      this.addEventListener('focusin', () => {
        this.isPaused = true;
      });

      this.addEventListener('focusout', () => {
        this.isPaused = false;
      });

      this.mql.addEventListener('change', this.handleMqChange);
      this.handleMqChange(this.mql);
    }

    disconnectedCallback() {
      this.stop();
      this.mql.removeEventListener('change', this.handleMqChange);
    }

    handleMqChange(event) {
      if (event.matches) {
        this.start();
      } else {
        this.stop();
        this.track.scrollTo({ left: 0, behavior: 'auto' });
      }
    }

    start() {
      if (this.timeout) return;

      const next = () => {
        if (!this.isPaused && this.mql.matches) {
          this.currentIndex = (this.currentIndex + 1) % this.slides.length;
          const nextSlide = this.slides[this.currentIndex];
          this.track.scrollTo({
            left: nextSlide.offsetLeft,
            behavior: 'smooth'
          });
        }

        this.timeout = window.setTimeout(next, this.delay);
      };

      this.timeout = window.setTimeout(next, this.delay);
    }

    stop() {
      if (this.timeout) {
        window.clearTimeout(this.timeout);
        this.timeout = null;
      }
      this.currentIndex = 0;
    }
  }

  customElements.define('c-icons-with-text-slider', CIconsWithTextSlider);
}